module.exports = __webpack_public_path__ + "static/media/cross-red.517a4d52.svg";